import type { PrimitiveAtom } from 'jotai';
import { atom } from 'jotai';
import { getDefaultStore } from 'jotai/vanilla';

import { type OnlineUserInfo } from '@/components/providers/OnlineUserInfoProvider';

/**
 * @deprecated onlineUserInfoAtom을 사용해 주세요.
 */
export const onlineUserIdAtom = atom<string>('');

/**
 * @description OnlineUserInfoProvider에서 초기화가 이루어집니다.
 *              초기화 전에는 undefined입니다.
 *              cookie에 userinfo가 존재한다면 OnlineUserInfo가 설정됩니다.
 *              cookie에 userinfo가 존재하지 않는다면 null이 설정됩니다.
 */
export const onlineUserInfoAtom = atom<OnlineUserInfo | null | undefined>(
  undefined,
) as PrimitiveAtom<OnlineUserInfo | null | undefined>;

export const tokenAtom = atom<{ isLoading: boolean; token: string | null }>({
  isLoading: true,
  token: null,
});

export const authStore = getDefaultStore();
authStore.set(onlineUserInfoAtom, undefined);
authStore.set(tokenAtom, { isLoading: true, token: null });
